import { render, staticRenderFns } from "./WorkExperience.vue?vue&type=template&id=3b5f5701&scoped=true"
import script from "./WorkExperience.vue?vue&type=script&lang=js"
export * from "./WorkExperience.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5f5701",
  null
  
)

export default component.exports